import { render, staticRenderFns } from "./KS-SL-Disclosure.vue?vue&type=template&id=242a47e6&scoped=true&"
import script from "./KS-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./KS-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./KS-SL-Disclosure.vue?vue&type=style&index=0&id=242a47e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a47e6",
  null
  
)

export default component.exports